import { useToast } from '@barfacil/barfacil-ui'
import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { useState } from 'react'

import { UpdateCurrentCompanyParams } from '@/api/_schemas/companies'
import { updateCurrentCompany } from '@/api/companies'
import { ApiError } from '@/config/api'
import { useAuthContext } from '@/contexts/auth-context'
import { handleErrors } from '@/services/fetch'

export const useUpdateCurrentCompany = () => {
  const [openDialog, setOpenDialog] = useState(false)

  const { login } = useAuthContext()
  const { toastDestructive } = useToast()

  const mutation = useMutation({
    mutationFn: async ({ id }: UpdateCurrentCompanyParams) => {
      const {
        token_agp: tokenAgp,
        token_bf: tokenBf,
        pessoa,
      } = await updateCurrentCompany({ id })

      await login({
        tokenAgp,
        tokenBf,
      })

      return { tokenAgp, tokenBf, pessoa }
    },
    onSuccess: closeDialog,
    onError: ({ response }: AxiosError<ApiError>) => {
      const message = response?.data.message ?? ''
      if (message.includes('[AGP]')) {
        setOpenDialog(true)
        return
      }

      if (response?.status === 401) return

      handleErrors(response?.data, [], toastDestructive)
    },
  })

  function closeDialog() {
    setOpenDialog(false)
  }

  return { mutation, openDialog, closeDialog }
}
